import { createRootRoute, Outlet } from '@tanstack/react-router'
import '../styles/index.css'
import '../styles/colors.css'

export const Route = createRootRoute({
  component: RootLayout,
})

// Minimal branded shell — no DashboardShell/AuthProvider/RbacProvider here,
// every route under this root is public (see docs/architecture.md).
function RootLayout() {
  return (
    <>
      <Outlet />
    </>
  )
}
